
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index9A4x8B_Af_45IFZXCU7bY1IswqQ43D7Dyr5qIiaf8nBzMMeta } from "/myedvenn/pages/index.vue?macro=true";
import { default as loginakkupO74aKIOGBCWWQnraYtpziu5MhbNenipB29PuiUMeta } from "/myedvenn/pages/login.vue?macro=true";
import { default as accountOuQC0Z5tXG6e2bNA2JYQ2QIg1LojaHQkdy8zE3LsSbEMeta } from "/myedvenn/pages/account.vue?macro=true";
import { default as welcomeKXXR3TNrzJHlyr2A2jU1T6vAK8WpIRRkgWcdj68JKm0Meta } from "/myedvenn/pages/welcome.vue?macro=true";
import { default as _91_46_46_46404_93WiAAZ_VzF3T_kxzgVXzBPivh4DfNYRJbrxDbo5Vp_452AMeta } from "/myedvenn/pages/[...404].vue?macro=true";
import { default as maintenanceUhQ06_z_45OoVNBGH3CAsvWnFMv62J6oy7b41n2isNrXgMeta } from "/myedvenn/pages/maintenance.vue?macro=true";
import { default as indexFaEITFXlx7ibKHpUCLSm1JbkygON1UvFC05WBWtxS1QMeta } from "/myedvenn/pages/training/[id]/index.vue?macro=true";
import { default as calendarV9BG4vdt_45IiKpE5Cjn8_45RZEbuFfTiMQNzhOOzySWkNgMeta } from "/myedvenn/pages/training/[id]/calendar.vue?macro=true";
import { default as contractBYyEYWhB_oG6RJTa29YoESIyYBE_ulNFZVYNOz7BKRIMeta } from "/myedvenn/pages/training/[id]/contract.vue?macro=true";
import { default as attendanceZQG3_ohz4Y_HIyqMh5DbblzFCMUfukaZnM3iZ6pJZf8Meta } from "/myedvenn/pages/training/[id]/attendance.vue?macro=true";
import { default as _91id_93bsx2ToTqi8dS0BwbxdmeG9GEhLB1_dX1VNvghpq2dlkMeta } from "/myedvenn/pages/training/[id].vue?macro=true";
import { default as password_reset4G6L23A3dj1i2hs_45BSo8YsZuamNVnyT6k10EuBC0OcQMeta } from "/myedvenn/pages/password_reset.vue?macro=true";
import { default as dataWPvhW6PX_45dM8NOywWkF37WBMADDuBEG8BldBsqD1q1gMeta } from "/myedvenn/pages/admin/market/data.vue?macro=true";
import { default as leadky58cWNWuIQK7Tm51uuB5UjETGXBNDAPFXHRXcBhtroMeta } from "/myedvenn/pages/admin/market/lead.vue?macro=true";
import { default as reportrAZGxtWN5dtjBdLz_Oj_kTdUvKTIf_TbvGhZx_6iLmgMeta } from "/myedvenn/pages/admin/admin/report.vue?macro=true";
import { default as contactqI7HUYbDrLGhHu_45ieiTbHS_45zauQsktmDkzLboOcWJ7UMeta } from "/myedvenn/pages/admin/admin/contact.vue?macro=true";
import { default as search06MMskTrso7VS_wwSvqgg1H21GmIu9mK0Oiyldx7NUMMeta } from "/myedvenn/pages/admin/contact/search.vue?macro=true";
import { default as indexOJaLLXCHwEQs2ZFE3u5zI_bZVpp4k899Et8Sw_PrJG0Meta } from "/myedvenn/pages/admin/contact/[contactId]/index.vue?macro=true";
import { default as history2zpU_yhhYS_TIDD3y9dmbDohK5GcW0f_VOeBLNbQV7EMeta } from "/myedvenn/pages/admin/contact/[contactId]/training/[packageFileId]/history.vue?macro=true";
import { default as invoiceoHxghuQQSJPamoMiPbtJZMEJSFsiD6Z_KdP9sirMEtcMeta } from "/myedvenn/pages/admin/contact/[contactId]/training/[packageFileId]/invoice.vue?macro=true";
import { default as pedagogicalSwuLcZNC5CbjRgMrlgD0pTtovPZ2VF0nisBJK5wMN7oMeta } from "/myedvenn/pages/admin/contact/[contactId]/training/[packageFileId]/pedagogical.vue?macro=true";
import { default as administrativeXGjd8p_OPchWX6a8yS8VofbYgQ2aaWOKyzYSazuu11sMeta } from "/myedvenn/pages/admin/contact/[contactId]/training/[packageFileId]/administrative.vue?macro=true";
import { default as _91packageFileId_93nIJMYo77qf68B_X9mEI6kMpzf2cWDZNZxWka6NQkXCMMeta } from "/myedvenn/pages/admin/contact/[contactId]/training/[packageFileId].vue?macro=true";
import { default as _91contactId_93XeJeOElrxVhYGIwguWTXHO9zI_45t8GD46MH3DT9B4tIsMeta } from "/myedvenn/pages/admin/contact/[contactId].vue?macro=true";
import { default as assignsA0pjDbSCJJ4V4do0OQT_Us4loRSOwGdt4UFbC6FwpUQMeta } from "/myedvenn/pages/admin/pedagogical/assigns.vue?macro=true";
import { default as contactsRp5BCg90soHoLMsHngjd7jQawQxh_OPEksnxExUTGTUMeta } from "/myedvenn/pages/admin/pedagogical/contacts.vue?macro=true";
import { default as _91attendanceId_93ORdP_NpK3jei1bv6MWbPSphKMk9NE94bEOvqGKYBS84Meta } from "/myedvenn/pages/training/attendance/[attendanceId].vue?macro=true";
import { default as attendance_45_91status_93C_4_45oxfn1C71V_c9rr1gBuE8g_JjXQ__45jQf_RBlC6ggMeta } from "/myedvenn/pages/admin/administrative/attendance-[status].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/myedvenn/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/myedvenn/pages/login.vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/myedvenn/pages/account.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    component: () => import("/myedvenn/pages/welcome.vue")
  },
  {
    name: "404",
    path: "/:404(.*)*",
    component: () => import("/myedvenn/pages/[...404].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/myedvenn/pages/maintenance.vue")
  },
  {
    name: _91id_93bsx2ToTqi8dS0BwbxdmeG9GEhLB1_dX1VNvghpq2dlkMeta?.name,
    path: "/training/:id()",
    component: () => import("/myedvenn/pages/training/[id].vue"),
    children: [
  {
    name: "training-id",
    path: "",
    component: () => import("/myedvenn/pages/training/[id]/index.vue")
  },
  {
    name: "training-id-calendar",
    path: "calendar",
    component: () => import("/myedvenn/pages/training/[id]/calendar.vue")
  },
  {
    name: "training-id-contract",
    path: "contract",
    component: () => import("/myedvenn/pages/training/[id]/contract.vue")
  },
  {
    name: "training-id-attendance",
    path: "attendance",
    component: () => import("/myedvenn/pages/training/[id]/attendance.vue")
  }
]
  },
  {
    name: "password_reset",
    path: "/password_reset",
    component: () => import("/myedvenn/pages/password_reset.vue")
  },
  {
    name: "admin-market-data",
    path: "/admin/market/data",
    component: () => import("/myedvenn/pages/admin/market/data.vue")
  },
  {
    name: "admin-market-lead",
    path: "/admin/market/lead",
    component: () => import("/myedvenn/pages/admin/market/lead.vue")
  },
  {
    name: "admin-admin-report",
    path: "/admin/admin/report",
    component: () => import("/myedvenn/pages/admin/admin/report.vue")
  },
  {
    name: "admin-admin-contact",
    path: "/admin/admin/contact",
    component: () => import("/myedvenn/pages/admin/admin/contact.vue")
  },
  {
    name: "admin-contact-search",
    path: "/admin/contact/search",
    component: () => import("/myedvenn/pages/admin/contact/search.vue")
  },
  {
    name: _91contactId_93XeJeOElrxVhYGIwguWTXHO9zI_45t8GD46MH3DT9B4tIsMeta?.name,
    path: "/admin/contact/:contactId()",
    component: () => import("/myedvenn/pages/admin/contact/[contactId].vue"),
    children: [
  {
    name: "admin-contact-contactId",
    path: "",
    component: () => import("/myedvenn/pages/admin/contact/[contactId]/index.vue")
  },
  {
    name: "admin-contact-contactId-training-packageFileId",
    path: "training/:packageFileId()",
    component: () => import("/myedvenn/pages/admin/contact/[contactId]/training/[packageFileId].vue"),
    children: [
  {
    name: "admin-contact-contactId-training-packageFileId-history",
    path: "history",
    component: () => import("/myedvenn/pages/admin/contact/[contactId]/training/[packageFileId]/history.vue")
  },
  {
    name: "admin-contact-contactId-training-packageFileId-invoice",
    path: "invoice",
    component: () => import("/myedvenn/pages/admin/contact/[contactId]/training/[packageFileId]/invoice.vue")
  },
  {
    name: "admin-contact-contactId-training-packageFileId-pedagogical",
    path: "pedagogical",
    component: () => import("/myedvenn/pages/admin/contact/[contactId]/training/[packageFileId]/pedagogical.vue")
  },
  {
    name: "admin-contact-contactId-training-packageFileId-administrative",
    path: "administrative",
    component: () => import("/myedvenn/pages/admin/contact/[contactId]/training/[packageFileId]/administrative.vue")
  }
]
  }
]
  },
  {
    name: "admin-pedagogical-assigns",
    path: "/admin/pedagogical/assigns",
    component: () => import("/myedvenn/pages/admin/pedagogical/assigns.vue")
  },
  {
    name: "admin-pedagogical-contacts",
    path: "/admin/pedagogical/contacts",
    component: () => import("/myedvenn/pages/admin/pedagogical/contacts.vue")
  },
  {
    name: "training-attendance-attendanceId",
    path: "/training/attendance/:attendanceId()",
    component: () => import("/myedvenn/pages/training/attendance/[attendanceId].vue")
  },
  {
    name: "admin-administrative-attendance-status",
    path: "/admin/administrative/attendance-:status()",
    component: () => import("/myedvenn/pages/admin/administrative/attendance-[status].vue")
  },
  {
    path: "/admin/pedagogical",
    redirect: "/admin/pedagogical/contacts"
  },
  {
    path: "/admin/admin",
    redirect: "/admin/admin/report"
  },
  {
    path: "/admin/administrative",
    redirect: "/admin/administrative/attendance-validation"
  },
  {
    path: "/admin/market",
    redirect: "/admin/market/data"
  }
]